import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Lock } from 'lucide-react';
import { Mockup3D } from './Mockup3D';
export function CheckoutSection() {
  return;
}